import request from 'Request'

const MessagesService = {
  async sendMessage({ tCode, messageTitle, messageBody, link, categoryId }) {
    return request.post('/messages/sendMessage', {
      tCode,
      messageTitle,
      messageBody,
      link,
      categoryId
    })
  }
}

export default MessagesService
